<div class="flex flex-col gap-1 flex-wrap">
  <div class="flex flex-row justify-start gap-2">
    <span class=" text-gray-500">Motivo da viagem: <span class="font-bold"> {{ isEmpty(fnrh.motivoViagem) ? fnrh.motivoViagem : 'Selecionar' }}</span></span>
    <span class=" text-gray-500">Transporte utilizado: <span class="font-bold"> {{ isEmpty(fnrh.transporteUtilizado) ? fnrh.transporteUtilizado : 'Selecionar'
        }}</span></span>
  </div>
  <span class=" text-gray-500">Observação: <span class="font-bold"> {{ isEmpty(fnrh.observacao) ? fnrh.observacao : 'Adicionar observação'  }} </span></span>

</div>
